/* eslint-disable @typescript-eslint/no-unused-vars */
import { TabPanel, TabsHorizontal } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { RulesFace, RulesIP, RulesTabsWrapper } from '../components';

export const RulesPage = () => {
  return (
    <>
      <RulesTabsWrapper flexDirection="column">
        <RulesFace />
      </RulesTabsWrapper>
    </>
  );
};
